import type { Organization } from '@/types/Organization'

export const getNewOpportunitiesUrl = (org: Organization) => {
  const defaultOpportunityType = org.default_opportunity_type
  const query = encodeURIComponent(org.website_url ?? org.description ?? '')
  switch (defaultOpportunityType) {
    case 'federal_contract':
      return `/federal-contracts/search?query=${query}`
    case 'federal_grant':
      return `/federal-grants/search?query=${query}`
    case 'sbir':
      return `/sbirs/search?query=${query}`
    case 'sled_contract':
      return `/sled-contracts/search?query=${query}`
    case 'dibbs_contract':
      return `/dibbs-contracts/search?query=${query}`
    default:
      const exhaustiveCheck: never = defaultOpportunityType
      throw new Error(`Unknown opportunity type: ${exhaustiveCheck}`)
  }
}
